<div
  role="listbox"
  class="select select__single select--pristine select--bottom select--touched select__demo-spacing"
  [ngClass]="{ 'select--open': isOpen, 'select--error': error, 'select--disabled': disabled }"
>
  <div #trigger class="select__container" (click)="open()" (mousedown)="mousedown()">
    <div class="select__value-container">
      <div class="select__placeholder" *ngIf="!(value && value.length)">
        {{ placeholder | translate }}
      </div>

      <div class="select__value" *ngIf="!!(value && value.length)">
        <div class="select__value-label">
          <span>
          {{value.length}}&nbsp;{{ ('core.label.selected' | translate).toLowerCase() }}
          </span>
        </div>
      </div>
    </div>
    <span class="select__arrow-wrapper">
      <span class="select__arrow"></span>
    </span>
    <div class="select__icon">
      <svg-icon
        *ngIf="!isOpen"
        name="ico-caret-down-16"
        [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
      ></svg-icon>
      <svg-icon
        *ngIf="isOpen"
        name="ico-caret-up-16"
        [svgStyle]="{ 'width.px': '16', 'height.px': '16', fill: 'currentColor' }"
      >
      </svg-icon>
    </div>
  </div>

  <wfm-dropdown [adjustVerticalOverflow]="true" [disabled]="disabled" [(isOpen)]="isOpen"
                (isOpenChange)="isOpenChange()">
    <wfm-virtual-list *ngIf="isOpen" [style.min-width.px]="minWidth"
                      [isShowSelected]="isShowSelected"
                      [items]="items"
                      [multiple]="multiple"
                      [headerVisible]="true"
                      [labelField]="labelField"
                      [selectedItems]="value"
                      [searchLabel]="searchLabel"
                      [searchIcon]="searchIcon"
                      [enableInternalSearch]="enableInternalSearch"
                      [disableByField]="disableByField"
                      (queryStr)="queryStr.emit($event)"
                      (selectedItemsChange)="getSelectedItems($event)">
    </wfm-virtual-list>
  </wfm-dropdown>
</div>
